<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'
import Text from '@uiKit/elements/Text.vue'

interface TrustItem {
  label: string
  icon: 'lock' | 'shield' | 'verified'
}

const items: TrustItem[] = [
  { label: 'Escrow Protected', icon: 'lock' },
  { label: 'VARA Regulated', icon: 'shield' },
  { label: 'DLD Verified', icon: 'verified' },
]
</script>

<template>
  <Box class="trust-chips">
    <Box
      v-for="item in items"
      :key="item.label"
      class="trust-chips__item"
      align="center"
      gap="2"
    >
      <PiIcon :name="item.icon" class="trust-chips__icon" />
      <Text type="caption" weight="medium" color="default">{{ item.label }}</Text>
    </Box>
  </Box>
</template>

<style scoped>
.trust-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.trust-chips__item {
  padding: 0.4rem 0.75rem;
  border: 1px solid var(--p-content-border-color);
  border-radius: 999px;
  background: var(--p-surface-0);
}

.trust-chips__icon {
  font-size: 12px;
  color: var(--p-text-color);
  opacity: 0.75;
}
</style>
